// src/pages/onboarddeboard/employees/roleAllocation/page.js

import React, { useState, useEffect, useCallback } from "react";

import { Table } from "react-bootstrap";

import { toast, ToastContainer } from "react-toastify";

import "react-toastify/dist/ReactToastify.css";

import { getAllEmployees } from "../../../api/onboarddeboard";

import { assignUserRole, getAllRoles } from "../../../api/roleAllocation";



// roleId map: 1=SUPERADMIN, 2=ADMIN, 3=EMPLOYEE, 4=USER, 5=HR, 6=TEAM_LEAD





const ROLE_ID_MAP = {

  1: "Super Admin",

  2: "Admin",

  3: "Employee",

  4: "User",

  5: "HR",

  6: "Team Lead",

};



const AVATAR_BG = "#dce8fb";

const AVATAR_FG = "#2563eb";

const ROW_HEIGHT = 64;



const getInitials = (name) => {

  if (!name || !name.trim()) return "?";

  return name.trim().split(/\s+/).filter(Boolean).slice(0, 2).map((w) => w[0].toUpperCase()).join("");

};



const Avatar = ({ name }) => (

  <div style={{

    width: 36, height: 36, borderRadius: "50%", flexShrink: 0,

    background: AVATAR_BG,

    display: "flex", alignItems: "center", justifyContent: "center",

    fontSize: 13, fontWeight: 700, color: AVATAR_FG, userSelect: "none",

  }}>

    {getInitials(name)}

  </div>

);



const RoleAllocation = () => {

  const token = localStorage.getItem("token");



  const [employees, setEmployees] = useState([]);

  const [loading, setLoading] = useState(true);

  const [searchQuery, setSearchQuery] = useState("");



  const [rowState, setRowState] = useState({});

  const [bulkSubmitting, setBulkSubmitting] = useState(false);

  const [roleOptions, setRoleOptions] = useState([]);

 



  const fetchEmployees = useCallback(async () => {

    setLoading(true);

    try {

      const res = await getAllEmployees(token);

      console.log("fetchedemployee res",res.data);

      const list = res.data || [];

      setEmployees(list);



      const initialState = {};

      list.forEach((emp) => {

        initialState[emp.userInfoId] = { checked: false, selectedRoleId: null };

      });

      setRowState(initialState);

    } catch (err) {

      toast.error("Failed to load employees");

    } finally {

      setLoading(false);

    }

  }, [token]);



    const fetchRoles = useCallback(async () => {

  try {

    const res = await getAllRoles(token);



    const roles = (res.data || [])
  .filter(role => !["SUPERADMIN", "USER"].includes(role.role))
  .map(role => ({
    id: role.id,
    label: role.role.replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase()),
  }));


    setRoleOptions(roles);

  } catch (err) {

    toast.error("Failed to load roles");

  }

}, [token]);



useEffect(() => {

  fetchEmployees();

  fetchRoles();

}, [fetchEmployees, fetchRoles]);



  const toggleCheck = (userId) => {

    setRowState((prev) => ({

      ...prev,

      [userId]: { ...prev[userId], checked: !prev[userId].checked, selectedRoleId: !prev[userId].checked ? prev[userId].selectedRoleId : null },

    }));

  };



  const setRole = (userId, roleId) => {

    setRowState((prev) => ({

      ...prev,

      [userId]: { ...prev[userId], selectedRoleId: roleId },

    }));

  };



  const checkedUserIds = Object.keys(rowState).filter(

    (uid) => rowState[uid].checked && rowState[uid].selectedRoleId

  );



  const submitBulk = async () => {

    if (checkedUserIds.length === 0) {

      toast.error("Please check at least one row and select a role");

      return;

    }

    setBulkSubmitting(true);

    let successCount = 0;

    let failCount = 0;



    for (const uid of checkedUserIds) {

      const roleId = rowState[uid].selectedRoleId;

      try {

        await assignUserRole(Number(uid), roleId, token);

        successCount++;

      } catch (err) {

        failCount++;

      }

    }



    setEmployees((prev) =>

      prev.map((e) => {

        const uidStr = String(e.userInfoId);

        if (checkedUserIds.includes(uidStr)) {

          const roleId = rowState[uidStr].selectedRoleId;

          return { ...e, role: { id: roleId, role: roleOptions.find((r) => r.id === roleId)?.label } };

        }

        return e;

      })

    );



    setRowState((prev) => {

      const next = { ...prev };

      checkedUserIds.forEach((uid) => {

        next[uid] = { checked: false, selectedRoleId: null };

      });

      return next;

    });



    setBulkSubmitting(false);



    if (successCount > 0) toast.success(`${successCount} role(s) updated successfully`);

    if (failCount > 0) toast.error(`${failCount} role update(s) failed`);

  };



  const cancelSelection = () => {

    setRowState((prev) => {

      const next = { ...prev };

      Object.keys(next).forEach((uid) => {

        next[uid] = { checked: false, selectedRoleId: null };

      });

      return next;

    });

  };



  const filtered = employees.filter((emp) => {

    const q = searchQuery.toLowerCase();

    return (

      (emp.name || "").toLowerCase().includes(q) ||

      (emp.departmentName || "").toLowerCase().includes(q) ||

      (emp.emp_Id || "").toLowerCase().includes(q)

    );

  });



  return (

    <div style={{ fontFamily: "inherit", paddingBottom: checkedUserIds.length > 0 ? 90 : 16 }}>
      <ToastContainer position="top-right" autoClose={3000} />



      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 16, flexWrap: "wrap", gap: 12 }}>

        <div>

        <h4 className="page-main-heading">Role Allocation</h4>
<div className="page-sub-heading">Assign roles to onboarded employees</div>

        </div>



        <input

          type="text"

          placeholder="Search by name, department, ID..."

          value={searchQuery}

          onChange={(e) => setSearchQuery(e.target.value)}

          style={{

            border: "1px solid #ced4da", borderRadius: 6, padding: "8px 14px",

            fontSize: 14, width: 260, outline: "none",

          }}

        />

      </div>



      <div style={{ background: "#fff", borderRadius: 10, boxShadow: "0 1px 4px rgba(0,0,0,0.07)", overflow: "hidden", width: "100%" }}>

        <div style={{ overflowX: "auto" }}>

          <Table hover responsive className="mb-0 align-middle" style={{ width: "100%", tableLayout: "fixed", minWidth: 500 }}>

            <thead>

              <tr style={{ borderBottom: "2px solid #2E5CB8" }}>

                <th style={{ padding: "14px 20px", fontWeight: 600, color: "#fff", background: "#2E5CB8", width: "40%", borderRight: "1px solid rgba(255,255,255,0.35)", borderTopLeftRadius: 8 }}>Name</th>

                <th style={{ padding: "14px 20px", fontWeight: 600, color: "#fff", background: "#2E5CB8", width: "30%", borderRight: "1px solid rgba(255,255,255,0.35)" }}>Department</th>

                <th style={{ padding: "14px 20px", fontWeight: 600, color: "#fff", background: "#2E5CB8", width: "30%", borderTopRightRadius: 8 }}>Role</th>

              </tr>

            </thead>

          </Table>

        </div>

<div>

          <div style={{ overflowX: "auto" }}>

            <Table hover responsive className="mb-0 align-middle" style={{ width: "100%", tableLayout: "fixed", minWidth: 500 }}>

              <tbody>

                {loading ? (

                  <tr><td colSpan={3} className="text-center py-5 text-muted">Loading employees...</td></tr>

                ) : filtered.length === 0 ? (

                  <tr><td colSpan={3} className="text-center py-5 text-muted">No employees found</td></tr>

                ) : (

                  filtered.map((emp) => {

                    const row = rowState[emp.userInfoId] || { checked: false, selectedRoleId: null };



                    return (

                      <tr key={emp.userInfoId}>

                        <td style={{ padding: "14px 20px", width: "40%" }}>

                          <div style={{ display: "flex", alignItems: "center", gap: 12 }}>

                            <input

                              type="checkbox"

                              checked={row.checked}

                              onChange={() => toggleCheck(emp.userInfoId)}

                              style={{ width: 16, height: 16, cursor: "pointer", accentColor: "#2E5CB8", flexShrink: 0 }}

                            />

                            <Avatar name={emp.name} />

                            <div>

                              <div style={{ fontWeight: 500, color: "#212529" }}>{emp.name || "—"}</div>

                              <div style={{ fontSize: 12, color: "#888" }}>{emp.emp_Id || ""}</div>

                            </div>

                          </div>

                        </td>



                        <td style={{ padding: "14px 20px", color: "#888", width: "30%" }}>

                          {emp.departmentName || "—"}

                        </td>



                        <td style={{ padding: "14px 20px", width: "30%" }}>

                         

                          <select

                            value={row.selectedRoleId ?? emp.role?.id ?? ""}

                            disabled={!row.checked}

                            onChange={(e) => setRole(emp.userInfoId, Number(e.target.value))}

                            style={{

                              border: "1px solid #ced4da",

                              borderRadius: 6,

                              padding: "6px 10px",

                              fontSize: 14,

                              minWidth: 160,

                              background: row.checked ? "#fff" : "#f3f4f6",

                              color: row.checked ? "#212529" : "#9ca3af",

                              cursor: row.checked ? "pointer" : "not-allowed",

                            }}

                          >

                            {!emp.role?.id && (

                              <option value="">Not Assigned</option>

                            )}

                            {roleOptions.map((r) => (

                              <option key={r.id} value={r.id}>

                                {r.label}

                              </option>

                            ))}

                          </select>

                        </td>

                      </tr>

                    );

                  })

                )}

              </tbody>

            </Table>

          </div>

        </div>

      </div>



      {checkedUserIds.length > 0 && (

        <div style={{

          position: "fixed", left: 0, right: 0, bottom: 0,

          background: "#fff", borderTop: "1px solid #e9ecef",

          padding: "14px 24px", display: "flex", justifyContent: "center",

          gap: 12, boxShadow: "0 -2px 8px rgba(0,0,0,0.06)", zIndex: 100,

        }}>

          <button

            onClick={submitBulk}

            disabled={bulkSubmitting}

            style={{

              background: bulkSubmitting ? "#cbd5e1" : "#2E5CB8",

              color: "#fff", border: "none", borderRadius: 8,

              padding: "10px 22px", fontSize: 14, fontWeight: 600,

              cursor: bulkSubmitting ? "not-allowed" : "pointer",

            }}

          >

            {bulkSubmitting ? "Submitting..." : `Submit Selected (${checkedUserIds.length})`}

          </button>

          <button

            onClick={cancelSelection}

            disabled={bulkSubmitting}

            style={{

              background: "#fff", color: "#374151", border: "1px solid #ced4da",

              borderRadius: 8, padding: "10px 22px", fontSize: 14, fontWeight: 600,

              cursor: bulkSubmitting ? "not-allowed" : "pointer",

            }}

          >

            Cancel

          </button>

        </div>

      )}

    </div>

  );

};



export default RoleAllocation;